import { UseMutationOptions } from 'react-query';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import MutationKeys from './keys';
import { UpdateVoiceContentInput } from 'domains/content/types';

const useUpdateVoiceContent = (
    voiceContentId: string,
    mutateOptions?: UseMutationOptions<unknown, Error, UpdateVoiceContentInput>
) =>
    useMutation<UpdateVoiceContentInput>(
        MutationKeys.UPDATE_VOICE_CONTENT,
        new PathWithID(CuredApiPaths.VOICE_CONTENT, parseInt(voiceContentId)),
        mutateOptions,
        ApiMethods.PUT
    );

export default useUpdateVoiceContent;
